import { ComponentType } from "react";
import { expensesMenuItems, searchMenuItems } from "~/application/data";
import { AgencyEmployeeType, User, UserActions, UserContexts } from "~/application/types";

import { Actions, UserContext } from "~/application/types";
import { SettingParameterSlug } from "~/application/types/entities/SettingParameter.type";

export type NavMenuModule =
  | "search"
  | "settings"
  | "expenses"
  | "order"
  | "dashboard"
  | "reporting-center"
  | "expense-report"
  | "advance"
  | "card"
  | "notifications"
  | undefined;

export type NavMenuItemType = {
  title: string;
  href: string;
  requiredContext?: UserContext;
  requiredActions: Actions[];
  icon?: ComponentType;
  action?: () => void;
};

export const filterMenuItems = (
  items: NavMenuItemType[],
  actions: UserActions,
  contexts: UserContexts,
  user?: User,
): NavMenuItemType[] => {
  const canRequestBizpayCard =
    contexts.customer?.settingsParameters?.find(
      (parameter) => parameter.slug === SettingParameterSlug?.CUSTOMER_CARD_STATUS,
    )?.value === "ACTIVE";
  const isAgencyAsCustomerEmployee = !!contexts?.agency && !!contexts.customer;

  const searchMenuTitles = searchMenuItems.map((menuItem) => menuItem.title);
  const expenseMenuTitles = expensesMenuItems.map((menuItem) => menuItem.title);

  return items
    .filter((item) => {
      if (item.title === "Meus cartões") {
        return canRequestBizpayCard;
      }

      if (
        item.title.includes("Dashboard BI") &&
        !!contexts.customer &&
        item.requiredContext === UserContext.Agency
      ) {
        return false;
      }

      if (
        item.title.includes("Dash") &&
        !!contexts.customer &&
        item.requiredContext === UserContext.Agency
      ) {
        return false;
      }

      if (isAgencyAsCustomerEmployee && searchMenuTitles.includes(item.title)) {
        return true;
      }

      if (isAgencyAsCustomerEmployee && item.href.startsWith("/central-de-relatorios")) {
        return true;
      }

      if (!!contexts.customer && item.title === "Ver pedidos" && !contexts.agency) {
        return false;
      }

      if (
        item.title.includes("Relatórios") &&
        user?.type !== AgencyEmployeeType.MANAGER &&
        !contexts.customer
      ) {
        return false;
      }

      if (
        !isAgencyAsCustomerEmployee &&
        expenseMenuTitles.includes(item.title) &&
        item.requiredContext === UserContext.Agency
      ) {
        return false;
      }

      if (!item.requiredContext) {
        return true;
      }

      return (
        item.requiredActions.every((action) => actions[action]) && contexts[item.requiredContext]
      );
    })
    .map((item) => {
      if (!item.requiredContext) {
        return item;
      }

      const isSeeOrdersMenu = item.title.includes("Ver pedidos");

      if (
        isAgencyAsCustomerEmployee &&
        isSeeOrdersMenu &&
        item.requiredContext.includes(UserContext.Agency) &&
        !item.title.includes("(Agência)")
      ) {
        item.title += " (Agência)";
      } else if (
        isAgencyAsCustomerEmployee &&
        isSeeOrdersMenu &&
        item.requiredContext.includes(UserContext.Customer) &&
        !item.title.includes("(Empresa)")
      ) {
        item.title += " (Empresa)";
      }

      return item;
    });
};
